<h2 class="heading-4">There was a problem loading details for your {{ vm.claimType }}</h2>
